export enum FeedbackType {
  Textual = 'textual',
  ScaleBased = 'scaleBased',
  TextualAndScaleBased = 'textualAndScaleBased',
}
